import axios from "../api";
/**
 * Every pool's squad for one challenge: club, both and market for a caller
 * with an imported club, market alone otherwise. The backend picks the pools.
 */
export const solveSbcSolutions = async (sbcId, body) => {
    const res = await axios.post(`/sbcs/${sbcId}/solutions`, {
        ...body,
        // The API still requires the rarity flags; the apps no longer offer them.
        excludeGoldPlayers: false,
        excludeSilverPlayers: false,
        excludeBronzePlayers: false,
        excludeSpecialPlayers: false,
    });
    return res.data;
};
//# sourceMappingURL=solveSbcSolutions.js.map